import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  EnterpriseContext,
  EnterpriseContextState,
} from '../../modules/EnterpriseContext/EnterpriseContextInterfaces';

const initialState: EnterpriseContextState = {
  id: '',
  createdAt: 0,
  updatedAt: 0,
  enterpriseContext: {} as EnterpriseContext,
};

// Create the slice
export const enterpriseContextSlice = createSlice({
  name: 'enterpriseContext',
  initialState,
  reducers: {
    updateEnterpriseContext: (state, action: PayloadAction<Partial<EnterpriseContextState>>) => {
      return { ...state, ...action.payload };
    },
    resetEnterpriseContext: () => initialState,
  },
});

// Export actions and reducer
export const { updateEnterpriseContext, resetEnterpriseContext } = enterpriseContextSlice.actions;
export default enterpriseContextSlice.reducer;
